import { publicEnv } from "@/config/env";
import ProductsList from "@/features/products/components/product-list/product-list";
import { HeroMarkdownArticleGroupTagSection } from "@/features/shared/components/hero-markdown-section-client";
import { HeroMarkdownSkeleton } from "@/features/shared/components/hero-markdown-skeleton";
import { NotFoundPage } from "@/features/shared/components/not-found-page";
import { useLng } from "@/hooks/use-lng";
import { formatAppTitle } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/_app/articlegroups/$id/")({
  head: ({ params }) => {
    const decodedTag = decodeURIComponent(params.id);
    const tag = decodedTag.slice(0, 1).toUpperCase() + decodedTag.slice(1);
    return {
      meta: [{ title: formatAppTitle(tag) }]
    };
  },
  component: ArticlegroupDetailPage
});

function ArticlegroupDetailPage() {
  const { id } = Route.useParams();
  const lng = useLng();
  const decodedTag = decodeURIComponent(id);

  if (publicEnv.USE_ARTICLE_GROUP === "false") {
    return <NotFoundPage />;
  }

  return (
    <div className="flex h-full w-full flex-col">
      <Suspense fallback={<HeroMarkdownSkeleton className="max-h-[117px]" isArticleGroup />}>
        <HeroMarkdownArticleGroupTagSection lng={lng} tagSlug={decodedTag} />
      </Suspense>
      <ProductsList initialSelectedCategory={decodedTag} />
    </div>
  );
}
